// extracted by mini-css-extract-plugin
export default {"inputContainer":"CreateNewMessage_inputContainer__HVkcJ","input":"CreateNewMessage_input__BlrrH"};